import { MovieSpecialIcon } from '@/atoms/Icons/MovieSpecialIcon'
import { VideoCameraIcon } from '@/atoms/Icons/VideoCameraIcon'
import { VideoCameraOutlineIcon } from '@/atoms/Icons/VideoCameraOutlineIcon'
import { WatchIcon } from '@/atoms/Icons/WatchIcon'
import { OneColorIconProps } from '@/atoms/utils'
import { TorchApplicationType } from '@/types/codegen-federation'
import { ReactFCC } from '@/types/react'
import { TorchApplicationTypes } from '../../components/TorchApplicationContext'

export const TorchApplicationTypeIcon: ReactFCC<OneColorIconProps & { type?: TorchApplicationType | null }> = ({
  type,
  ...props
}) => {
  switch (type) {
    case TorchApplicationTypes.FullFilm:
      return <VideoCameraIcon {...props} />
    case TorchApplicationTypes.Concept:
      return <VideoCameraOutlineIcon {...props} />
    case TorchApplicationTypes.CompletedEpisode:
      return <WatchIcon {...props} />
    default:
      return <MovieSpecialIcon {...props} />
  }
}
